module.exports = __webpack_public_path__ + "img/logo_eduloc360_red.27eab939.png";